import lf from 'lovefield'

export function const_humidites (schemaBuilder) {
  schemaBuilder.createTable('const_humidites')
      .addColumn('id', lf.Type.INTEGER)
      .addColumn('code', lf.Type.STRING)
      .addColumn('nom', lf.Type.STRING)
      .addPrimaryKey(['code']);
}


/*

CREATE TABLE IF NOT EXISTS `const-humidites` (
  `code` varchar(10) NOT NULL COMMENT 'SEC / NEUTRE / HUMIDE',
  `nom` varchar(30) NOT NULL,
  PRIMARY KEY (`code`)
) ENGINE=InnoDB DEFAULT CHARSET=utf8;

*/



// WEBPACK FOOTER //
// ./src/client/common/db/schemas/constHumidites.schema.js